import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessageStarinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M12 5.999a4.5 4.5 0 0 0 4.5 4.5m0 0a4.5 4.5 0 0 0-4.5 4.5m0 0a4.5 4.5 0 0 0-4.5-4.5m0 0a4.5 4.5 0 0 0 4.5-4.5"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M18 3H6a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h2.007v2.443a.556.556 0 0 0 .903.434L12.507 18H18a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3",
		clipRule: "evenodd"
	})]
});
export default SvgMessageStarinline;
